import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Trophy, Lock } from 'lucide-react';

const rarityMap = {
  common: 'rarity-common bg-slate-50 text-slate-700',
  rare: 'rarity-rare bg-sky-50 text-sky-700',
  epic: 'rarity-epic bg-violet-50 text-violet-700',
  legendary: 'rarity-legendary bg-amber-50 text-amber-700',
};

export default function AchievementsPage() {
  const [all, setAll] = useState([]);
  const [mine, setMine] = useState([]);
  useEffect(() => {
    api.get('/achievements').then(r => setAll(r.data));
    api.get('/achievements/mine').then(r => setMine(r.data));
  }, []);
  const mineIds = new Set(mine.map(m => m.id));
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Mis logros" subtitle={`${mine.length} de ${all.length} desbloqueados`} testId="ach-header"/>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {all.map(a => {
          const unlocked = mineIds.has(a.id);
          return (
            <div key={a.id} data-testid={`ach-${a.id}`}
              className={`rounded-2xl p-5 border border-slate-200 bg-white ${unlocked ? rarityMap[a.rarity] || '' : 'opacity-60'}`}>
              <div className="flex items-center gap-3 mb-2">
                <div className={`w-12 h-12 rounded-2xl grid place-items-center ${unlocked ? 'bg-amber-500 text-white' : 'bg-slate-200 text-slate-500'}`}>
                  {unlocked ? <Trophy className="w-6 h-6"/> : <Lock className="w-5 h-5"/>}
                </div>
                <div>
                  <div className="font-display font-bold">{a.name}</div>
                  <div className="text-xs uppercase tracking-widest font-bold text-slate-500">{a.rarity} · +{a.points} pts</div>
                </div>
              </div>
              <div className="text-sm text-slate-600">{a.description}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
